import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** AI/CMS kaynaklı **kalın** vb. markdown kalıntılarını başlık/açıklamada temizler. */
export function stripMarkdown(text: string | null | undefined): string {
  if (!text) return "";
  return text
    .replace(/\*\*([\s\S]*?)\*\*/g, "$1")
    .replace(/__([\s\S]*?)__/g, "$1")
    .replace(/\*([^*\n]+)\*/g, "$1")
    .replace(/_([^_\n]+)_/g, "$1")
    .replace(/^#{1,6}\s+/gm, "")
    .replace(/`([^`]+)`/g, "$1")
    .replace(/\*\*/g, "")
    .replace(/\s{2,}/g, " ")
    .trim();
}

/** Blog etiketleri ve query URL'leri — API `slugify` ile aynı kural. */
export function slugifyTag(value: string): string {
  const map: Record<string, string> = {
    ç: "c",
    ğ: "g",
    ı: "i",
    İ: "i",
    ö: "o",
    ş: "s",
    ü: "u",
    Ç: "c",
    Ğ: "g",
    Ö: "o",
    Ş: "s",
    Ü: "u",
  };
  return value
    .toLowerCase()
    .split("")
    .map((c) => map[c] ?? c)
    .join("")
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 120);
}

export function formatTRY(amount: number): string {
  return new Intl.NumberFormat("tr-TR", {
    style: "currency",
    currency: "TRY",
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function formatDateTR(date: Date | string): string {
  const d = typeof date === "string" ? new Date(date) : date;
  return new Intl.DateTimeFormat("tr-TR", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  }).format(d);
}

/** Varsayılan destek WhatsApp (rakam). Ayar yoksa / geçersizse kullanılır. */
export const DEFAULT_WHATSAPP = "905513551839";
export const DEFAULT_SUPPORT_EMAIL = "destek@mersaakademi.com";
export const DEFAULT_SUPPORT_PHONE = "+90 551 355 18 39";

/** wa.me için yalnızca rakam; geçersizse varsayılan. */
export function sanitizeWhatsAppNumber(raw: string | undefined | null): string {
  if (!raw) return DEFAULT_WHATSAPP;
  const digits = raw.replace(/[^\d]/g, "");
  return digits.length >= 10 ? digits : DEFAULT_WHATSAPP;
}

export function whatsappHref(raw: string | undefined | null, message?: string): string {
  const base = `https://wa.me/${sanitizeWhatsAppNumber(raw)}`;
  if (!message) return base;
  return `${base}?text=${encodeURIComponent(message)}`;
}
